import styled, { css } from 'styled-components';
import { Divider } from '@amzn/storm-ui';
import { IntroWidgetAnchor } from '@amzn/intro-widgets-api';
import SVG from 'react-inlinesvg';
import { gray10, gray900, inkwell } from 'src/colors';

export const ToolbarWrapper = styled.div`
  background: ${gray10};
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  width: 60px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 13px;
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.1),
    1px 0px 5px 0px rgba(0, 0, 0, 0.1);
  padding-top: 5px;
`;

export const tooltipThemeOverride = (theme) => ({
  ...theme,
  tooltip: {
    ...theme.tooltip,
    mouseLeaveTimeout: 0,
    radius: '2px',
    paddingLeftRight: theme.spacing.mini,
    paddingTopBottom: theme.spacing.mini,
  },
  popover: {
    ...theme.popover,
    zIndex: 301,
    radius: '2px',
  },
});

export interface IconWrapperProps {
  isSelected: boolean | undefined;
}

const iconAnchorButtonStyles = css<IconWrapperProps>`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  width: 40px;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  border-radius: 5px;
  border-style: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  & img {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    width: 26px;
  }

  &:hover,
  &:focus {
    background-color: rgba(35, 47, 63, 0.05);
    background-image: none;

    ${(props) => {
      if (!props.isSelected) {
        return css`
          & path,
          rect {
            fill: ${inkwell};
          }
        `;
      }
    }}
  }

  &:active {
    transform: scale(0.95);
    transition-duration: 0.1s;

    ${(props) => {
      if (!props.isSelected) {
        return css`
          & path,
          rect {
            fill: ${inkwell};
          }
        `;
      }
    }}
  }

  ${(props) =>
    props.isSelected
      ? `
  path, rect { fill: inherit};
`
      : `path,
rect {
  fill: ${gray900};
}`};
`;

export const IconAnchor = styled.a`
  ${iconAnchorButtonStyles}
`;

export const IconButton = styled.button`
  ${iconAnchorButtonStyles}
`;

export const IconMarginWrapper = styled.div`
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const SvgWrapper = styled.div`
  box-sizing: unset;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export interface SvgIconWrapperProps {
  size: string;
}

export const SvgIconWrapper = styled(SVG)<SvgIconWrapperProps>`
  ${document.documentElement.dir === 'rtl' ? `transform: scaleX(-1);` : ``}
  ${(props) =>
    props.size === 'small'
      ? `
    display: block;
    width: 20px;
    height: 20px;
  `
      : ''};
`;

export const ToolbarIconsWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  text-align: center;
  background: ${gray10};
`;

export const BottomWrapper = styled(ToolbarIconsWrapper)`
  bottom: 13px;
`;

export const ToolbarDivider = styled(Divider)`
  margin: 13px 16px;
`;

export const StyledIntroWidgetAnchor = styled(IntroWidgetAnchor)`
  position: relative;
  display: block;
  width: 0;
  left: 28px;
`;
